import React, { useState } from "react";
import { Case, If } from "~/common/components/If";
import darkLogoImg from "~/assets/img/defaultImg/dark-logo-rec.png";
import lightLogoImg from "~/assets/img/defaultImg/light-logo-rec.png";
import twitterIco from "~/assets/img/ico-twitter.png";
import faceboockIco from "~/assets/img/ico-facebook.png";
import youtubeIco from "~/assets/img/sns_youtube.png";
import instagramIco from "~/assets/img/sns_instargram.png";
import linkedinIco from "~/assets/img/sns_linked in.png";

// import RoundInquiryPage from "~/pages/round/RoundManage/List/Tabs/roundInquiry";
import RoundFAQPage from "~/pages/round/RoundManage/List/Tabs/roundFAQ";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import TabMenu from "~/common/components/TabMenu";
import RoundDetailInfoPage from "~/pages/round/RoundManage/List/Tabs/roundDetail";
import { dateToString } from "~/utils/formatter";
import { useTranslation } from "react-i18next";
import translation from "~/i18n";
import { useGlobalStore } from "~/store";

const RoundDetail = ({
	roundDetailModal,
	setRoundDetailModal,
	setInquiryPreModal,
	roundDetailData,
}) => {
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	const { t } = useTranslation();
	const ModalTabMenuList = [
		{
			id: "detail",
			title: translation.t("pages.round.RoundList.component.RoundDetail.detail"),
		},
		{ id: "FAQ", title: "FAQ", disable: roundDetailData?.round?.Qna.length > 0 ? false : true },
		{
			id: "inquiry",
			title: translation.t("pages.round.RoundList.component.RoundDetail.inquiry"),
			disable: true,
		},
	];
	const [ModalTab, setModalTab] = useState("detail");
	return (
		<ModalTemplate
			modalState={roundDetailModal}
			setModalToggle={setRoundDetailModal}
			title={t("pages.round.RoundList.component.RoundDetail.roundTitle")}
			width={1100}
			className="round-detail-modal"
		>
			<div className="modal-content">
				<section className="rounding-main">
					<div className="rounding-main-header">
						<div>
							<h3 className="rounding-title">{roundDetailData?.round?.title}</h3>
							<div>
								<p className="host-name">
									{roundDetailData?.round?.VcCompany?.name}
								</p>
								<p className="host-site">
									<a
										target="_blank"
										href={`http://${roundDetailData?.round?.VcCompany?.homepage}`}
									>
										{roundDetailData?.round?.VcCompany?.homepage}
									</a>
								</p>
							</div>
						</div>
						<div className="rounding-status-wrap">
							<h4 className="rounding-status">{roundDetailData?.round?.status}</h4>
							<p className="rounding-update">
								{dateToString(roundDetailData?.round?.regDate, "yyyy-MM-dd")}
							</p>
						</div>
					</div>
					<div className="rounding-main-container">
						<div className="rounding-summary-left">
							<div className="rounding-img">
								<img
									src={roundDetailData?.round?.img}
									alt={t("pages.round.RoundManage.List.imageAlt")}
								/>
								{/*<img src={lightRoundThumb} alt="지원 프로그램 썸네일" />*/}
							</div>
							<div className="rounding-host-wrap">
								<div className="rounding-host">
									<div className="rounding-host-logo">
										<img
											src={
												roundDetailData?.managerImg !== null
													? roundDetailData?.managerImg
													: theme === "dark"
														? darkLogoImg
														: lightLogoImg
											}
											alt={t(
												"pages.round.RoundList.component.RoundDetail.logo"
											)}
										/>
									</div>
									<dl className="rounding-host-data">
										<dt className="host-name">
											{roundDetailData?.round?.managerName}
										</dt>
										<dd className="host-email">
											{roundDetailData?.round?.managerEmail}
										</dd>
									</dl>
								</div>
								<ul className="share-sns">
									{roundDetailData?.round?.facebook && (
										<li>
											<a
												target="_blank"
												href={roundDetailData?.round?.facebook}
											>
												<button type="button">
													<img
														src={faceboockIco}
														alt={t(
															"pages.round.RoundList.component.RoundDetail.facebookIcon"
														)}
													/>
												</button>
											</a>
										</li>
									)}
									{roundDetailData?.round?.twitter && (
										<li>
											<a
												target="_blank"
												href={roundDetailData?.round?.twitter}
											>
												<button type="button">
													<img
														src={twitterIco}
														alt={t(
															"pages.round.RoundList.component.RoundDetail.twitterIcon"
														)}
													/>
												</button>
											</a>
										</li>
									)}
									{roundDetailData?.round?.instagram && (
										<li>
											<a
												target="_blank"
												href={roundDetailData?.round?.instagram}
											>
												<button type="button">
													<img
														src={instagramIco}
														alt={t(
															"pages.round.RoundList.component.RoundDetail.instagramIcon"
														)}
													/>
												</button>
											</a>
										</li>
									)}
									{roundDetailData?.round?.linkedin && (
										<li>
											<a
												target="_blank"
												href={roundDetailData?.round?.linkedin}
											>
												<button type="button">
													<img
														src={linkedinIco}
														alt={t(
															"pages.round.RoundList.component.RoundDetail.linkedInIcon"
														)}
													/>
												</button>
											</a>
										</li>
									)}
									{roundDetailData?.round?.youtube && (
										<li>
											<a
												target="_blank"
												href={roundDetailData?.round?.youtube}
											>
												<button type="button">
													<img
														src={youtubeIco}
														alt={t(
															"pages.round.RoundList.component.RoundDetail.youtubeIcon"
														)}
													/>
												</button>
											</a>
										</li>
									)}
								</ul>
							</div>
						</div>
						<div className="rounding-summary-right">
							<p className="rounding-summary">
								{roundDetailData?.round?.description}
							</p>
							<dl className="rounding-instructions">
								<div className="period">
									<dt>
										{t("pages.round.RoundList.component.RoundDetail.period")}
									</dt>
									<dd>
										{dateToString(
											roundDetailData?.round?.startDate,
											"yyyy-MM-dd"
										)}{" "}
										~{" "}
										{dateToString(
											roundDetailData?.round?.endDate,
											"yyyy-MM-dd"
										)}
									</dd>
								</div>
								<div className="place">
									<dt>
										{t("pages.round.RoundList.component.RoundDetail.place")}
									</dt>
									<dd>
										{roundDetailData?.round?.applyMethod !== "오프라인"
											? "온라인접수"
											: roundDetailData?.round?.zipCode &&
												roundDetailData?.round?.address
												? `(${roundDetailData?.round?.zipCode}) ${roundDetailData?.round?.address}\n${roundDetailData?.round?.addressDetail}`
												: "-"}
									</dd>
								</div>
							</dl>

							{/*<button*/}
							{/*	type="button"*/}
							{/*	className="btn__solid btn-status"*/}
							{/*	color="gray"*/}
							{/*	disabled*/}
							{/*>*/}
							{/*	마감되었습니다*/}
							{/*</button>*/}
							{roundDetailData?.round?.applyMethod === "온라인" ? (
								<a target="_blank" href={roundDetailData?.round?.survey}>
									<button
										type="button"
										className="btn__solid btn-status"
										color="primary"
									>
										정보 확인
									</button>
								</a>
							) : roundDetailData?.round?.applyMethod !== "오프라인" ? (
								<button
									type="button"
									className="btn__solid btn-status"
									color="primary"
									onClick={() => setInquiryPreModal(true)}
								>
									지원서 미리보기
								</button>
							) : (
								<></>
							)}
						</div>
					</div>
				</section>
				<section className="rounding-tabs-wrap">
					<TabMenu
						tabItem={ModalTabMenuList}
						currentTab={ModalTab}
						setCurrentTab={setModalTab}
					/>
					<If condition={ModalTab}>
						<Case condition={"detail"}>
							<RoundDetailInfoPage
								content={roundDetailData?.round?.content}
								files={roundDetailData?.files}
							/>
						</Case>
						<Case condition={"FAQ"}>
							<RoundFAQPage faqList={roundDetailData?.round?.Qna} />
						</Case>
						{/* <Case condition={"inquiry"}>
								<RoundInquiryPage />
							</Case> */}
					</If>
				</section>
			</div>
		</ModalTemplate>
	);
};

export default RoundDetail;
